import { ChangeDetectionStrategy, Component, ElementRef, ViewContainerRef, ViewEncapsulation, viewChild } from "@angular/core";

@Component({
  selector: "mn-modal",
  templateUrl: "./modal.component.html",
  styleUrls: ["./modal.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalComponent {
  public container = viewChild.required<ElementRef<HTMLDivElement>>("container");
  public content = viewChild.required("content", { read: ViewContainerRef });
}
